import { useMemo } from "react";
import { useAuthStoreShallow } from "@/features/authentication";
import { useGetCurrentUserQuery } from "@/shared/services";
import { type IMediaFolder, MediaFolderPermEnum } from "@/shared/types";

export const useMediaLibFolderPermission = (folderData: IMediaFolder) => {
  const { data: currentUser } = useGetCurrentUserQuery();
  const isAdmin = useAuthStoreShallow((s) => s.isAdminOrAdministrator);

  return useMemo(() => {
    if (isAdmin) {
      return MediaFolderPermEnum.Owner;
    }
    if (!folderData.users || folderData.openAccess) {
      return MediaFolderPermEnum.Editor;
    }

    const user = folderData.users.find((e) => e.id === currentUser?.oktaId);
    return user?.type ?? MediaFolderPermEnum.Editor;
  }, [folderData, isAdmin, currentUser]);
};
